import { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

const Layout = lazy(() => import('./layouts/layout'));
const InvoicesIndex = lazy(() => import('./pages/invoices'));
const OrdersIndex = lazy(() => import('./pages/orders'));
const QuotationsIndex = lazy(() => import('./pages/quotations'));

const getHostSubdomain = () => window.location.hostname.split('.')[0]?.toLowerCase();

function App() {
  const basename = import.meta.env.BASE_URL === '/' ? undefined : import.meta.env.BASE_URL.replace(/\/$/, '');
  const subdomain = getHostSubdomain();

  const pageRoutes =
    subdomain === 'invoice' ? (
      <>
        <Route index element={<InvoicesIndex />} />
        <Route path=":id" element={<InvoicesIndex />} />
      </>
    ) : subdomain === 'orders' ? (
      <>
        <Route index element={<OrdersIndex />} />
        <Route path=":id" element={<OrdersIndex />} />
      </>
    ) : subdomain === 'quotation' ? (
      <>
        <Route index element={<QuotationsIndex />} />
        <Route path=":id" element={<QuotationsIndex />} />
      </>
    ) : (
      <>
        <Route path="invoice">
          <Route index element={<InvoicesIndex />} />
          <Route path=":id" element={<InvoicesIndex />} />
        </Route>
        <Route path="orders">
          <Route index element={<OrdersIndex />} />
          <Route path=":id" element={<OrdersIndex />} />
        </Route>
        <Route path="quotation">
          <Route index element={<QuotationsIndex />} />
          <Route path=":id" element={<QuotationsIndex />} />
        </Route>
      </>
    );

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Layout />}>
          {pageRoutes}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
